import * as React from 'react';
import { Route } from 'react-router-dom';

import AboutUs from './about-us';
import Faq from './faq';
import Tnc from './tnc';
import Privacy from './privacy';
import Opportunity from './opportunity';
import ContactUs from './contact-us';

const Routes = ({ match }) => (
  <div>
    <Route path={`${match.url}/faq`} component={Faq} />
    <Route path={`${match.url}/tnc`} component={Tnc} />
    <Route path={`${match.url}/privacy`} component={Privacy} />
    <Route path={`${match.url}/opportunity`} component={Opportunity} />
    <Route path={`${match.url}/contact-us`} component={ContactUs} />
    <Route path={`${match.url}/about-us`} component={AboutUs} />
  </div>
);

export default Routes;
